import 'css-chunksrc/client/scenes/optimizedGantt/header/sort/styles.scss';export default {
  "sort": "_sort_ginn3_1",
  "label": "_label_ginn3_9",
  "input": "_input_ginn3_16",
  "placeholder": "_placeholder_ginn3_32",
  "icon": "_icon_ginn3_40",
  "listRoot": "_listRoot_ginn3_48",
  "list": "_list_ginn3_48",
  "item": "_item_ginn3_64",
  "option": "_option_ginn3_77",
  "selected": "_selected_ginn3_84",
  "opened": "_opened_ginn3_97"
};